import { Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FlashService } from '../flash/services/flash.service';
import clipboard from '../../utils/clipboard';

@Component({
  selector: 'app-dialog-token-success',
  templateUrl: './dialog-token-success.component.html',
  styleUrls: ['./dialog-token-success.component.sass']
})
export class DialogTokenSuccessComponent implements OnInit {
  token: any;

  constructor(
    public dialogRef: MatDialogRef<DialogTokenSuccessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private flashService: FlashService
  ) {
    this.token = data.token;
  }

  ngOnInit() {}

  onCopy() {
    clipboard(this.token.access_token);
    this.flashService.success('Token copied to clipboard');
  }

  onClose() {
    this.dialogRef.close();
  }
}
